<template>
  <v-container>
    <v-container class="noPaddingBtm">
      <v-card flat>
        <v-row>
          <v-col cols="5" class="headerTitle headerGroup noPaddingBtm">
            <v-row>
              <v-col class="noPaddingBtm">
                <ryou-select class="ryouSelectStyle" :label="'物件グループ'" :items="dynamicItems"
                  :itemText="'build_group_name'" :itemValue="'build_group_id'" v-model="selectOptionValue"
                  :value="selectOptionValue">
                </ryou-select>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
    </v-container>
    <v-container>
      <v-row>
        <v-col>
          <v-sheet height="64" style="margin-left: 43%">
            <v-toolbar flat>
              <v-btn fab text small color="grey darken-2" @click="calendarPrv" :disabled="arrowCtrlFlag">
                <v-icon x-large> mdi-chevron-left </v-icon>
              </v-btn>
              <v-toolbar-title>
                <h2>{{this.canderTitle}}</h2>
              </v-toolbar-title>
              <v-btn fab text small color="grey darken-2" @click="calendarNext" :disabled="arrowCtrlFlag">
                <v-icon x-large> mdi-chevron-right </v-icon>
              </v-btn>
              <v-spacer></v-spacer>
            </v-toolbar>
          </v-sheet>
          <v-sheet height="700">
            <v-calendar ref="calendar" v-model="focus" color="primary" :events="events" :type="type"
              @click:event="showEvent" @click:date="btnClick($event)">
              <template v-slot:day="props">
                <template v-for="(ent, index) in notOfferEventsDateList">
                  <div :key="index" class="disable" v-if="ent == props.date" style="text-align: center">
                    <!-- 提供無し -->
                  </div>
                </template>
              </template>
              <template v-slot:event="{ event }">
                <v-row>
                  <v-col style="text-align:center">
                    {{ event.name }}
                  </v-col>
                  <v-col style="text-align:center">
                    {{ event.count }}
                  </v-col>
                </v-row>
              </template>
            </v-calendar>
          </v-sheet>
        </v-col>
      </v-row>
    </v-container>
    <MealReservationConfirmationDayDialog ref="reservationConfirmationDialog" @reCalendar="calendarGet">
    </MealReservationConfirmationDayDialog>
  </v-container>
</template>

<script>
  import RyouSelect from "../../components/formInput/RyouSelect";
  import MealReservationConfirmationDayDialog from "./modules/MealReservationConfirmationDayDialog.vue";
  export default {
    name: "MealReservationConfirmation",
    components: {
      RyouSelect,
      MealReservationConfirmationDayDialog
    },
    data() {
      return {
        p2Form: true,
        focus: "",
        type: "month",
        canderTitle: "",//カレンダーのヘッダ
        hasEventsDateList: [],//メニューが存在する日付["YYYY-MM-dd","YYYY-MM-dd",...]
        hasEventsDateDetailedDataList: [],//メニューが存在する詳細データ
        mealNames: [],//日付の食事名[食事一,食事二,...]
        events: [],//メニューが存在毎日のイベント[ある日の食事一,食事二,...]
        notOfferEventsDateList: [],//提供無し日付["YYYY-MM-dd","YYYY-MM-dd",...]
        notOfferEventsDateDetailedDataList: [],//提供無し日付詳細データ
        selectOptionValue: "",
        dynamicItems: [],
        colors: [
          "#FF9800",//オレンジ
          "#673AB7",//深紫
          "#4CAF50",//緑
          "#E91E63",//ピンク
          "#3F51B5",//インディゴ
          "#009688",//teal
          "#FF5722",//深オレンジ
          "#8BC34A",//light-green
          "#D32F2F",//red darken-2
          "#1565C0"//blue darken-3
        ],
        arrowCtrlFlag: false
      };
    },
    created() {
      this.initData();
    },
    mounted() {
      this.canderTitle = this.initCanderValue(this.$refs.calendar.title);
    },
    watch: {
      selectOptionValue(value) {
        if (value != "") {
          this.calendarGet();
        }
      },
      canderTitle() {
        if (this.selectOptionValue != "") {
          this.calendarGet();
        }
      }
    },
    methods: {
      //日付をクリック
      btnClick(date) {

        this.canderTitle = date.year + "年" + date.month + "月";
        let getNowMonth = this.$refs.calendar.title.split("月 ");

        // 当月かどうかを判断
        if (date.month == getNowMonth[0]) {
          if (this.selectOptionValue != null && this.selectOptionValue != "") {
            let DialogData = this.calendarDialogDataGet(date.date);

            if (DialogData) {
              // パラメータ1:ダイアログ日付、パラメータ2:物件グループID、パラメータ3:日付の食事名
              this.$refs.reservationConfirmationDialog.getInputValue(date.date, this.selectOptionValue, this.mealNames);
            }
          }
        }
      },
      //イベントクリック
      showEvent(event) {
        if (this.selectOptionValue != null && this.selectOptionValue != "") {
          let DialogData = this.calendarDialogDataGet(event.day.date);

          if (DialogData) {
            // パラメータ1:ダイアログ日付、パラメータ2:物件グループID、パラメータ3:日付の食事名
            this.$refs.reservationConfirmationDialog.getInputValue(event.day.date, this.selectOptionValue, this.mealNames);
          }
        }
      },
      initData() {
        let params = {
          userId: this.$store.getters.getUserId,
          userClass: this.$store.getters.getUserClass,
        }
        //selectBoxで値を取る
        this.getRequest("/mealReservationConfirmation/buildGroupGet", params, this.$store.getters.getUserToken).then(data => {
          if (data.success) {
            this.dynamicItems = data.result;
          }
        });
      },
      //カレンダーデータ取得
      calendarGet() {

        // データクリア
        this.mealNames = [];
        this.events = [];
        this.hasEventsDateList = [];
        this.hasEventsDateDetailedDataList = [];
        this.notOfferEventsDateList = [];
        this.notOfferEventsDateDetailedDataList = [];
        this.$(".v-calendar-weekly__day:has(div.disable)").removeClass("mask");
        this.$("div.disable").remove();

        if (this.selectOptionValue != null && this.selectOptionValue != "") {
          var that = this;

          let mealClassParams = {
            buildGroupId: this.selectOptionValue
          };

          this.getRequest("/mealReservationConfirmation/mealClassGet", mealClassParams, this.$store.getters.getUserToken).then(data => {
            // 食事区分取得
            if (data.success) {
              that.mealNames = data.result;
            }
          });

          //年月取得
          let titleYear = this.canderTitle.split("年")
          let titleMonth = titleYear[1].split("月")
          let calendarParams = {
            buildGroupId: this.selectOptionValue,
            currentYM: titleYear[0] + "-" + titleMonth[0]
          };

          this.arrowCtrlFlag = true;

          this.getRequest("/mealReservationConfirmation/calendarReservationConfirmationGet", calendarParams, this.$store.getters.getUserToken).then(data => {
            if (data.success) {
              // 現在の月を循環
              for (let dateIndex = 0; dateIndex < data.result.length; dateIndex++) {

                //取得当日
                let dateItem = data.result[dateIndex];
                // 取得当日(Key,Value)
                for (let dateKey in dateItem) {

                  //取得当日データ
                  let dateData = dateItem[dateKey];
                  // 取得当日データあり
                  if (dateData.length != 0) {
                    // データが存在する日付
                    if (dateData[0].offer_flg == "1") {
                      //食事提供あり結果セット
                      if (that.hasEventsDateList.indexOf(dateKey) < 0) {
                        that.hasEventsDateList.push(dateKey);
                        that.hasEventsDateDetailedDataList.push(dateItem);
                      }
                    } else if (dateData[0].offer_flg == "0") {
                      //食事提供なし結果セット
                      if (that.notOfferEventsDateList.indexOf(dateKey) < 0) {
                        that.notOfferEventsDateList.push(dateKey);
                        that.notOfferEventsDateDetailedDataList.push(dateItem);
                      }
                    }
                  }
                }
              }

              this.getValue();
            }
            this.arrowCtrlFlag = false;
          });
        }
      },
      //カレンダー、ポップアップ、データ取得
      calendarDialogDataGet(value) {
        for (let hedddIndex = 0; hedddIndex < this.hasEventsDateDetailedDataList.length; hedddIndex++) {

          let hedddItem = this.hasEventsDateDetailedDataList[hedddIndex];

          for (let hedddKey in hedddItem) {
            if (hedddKey == value) {
              return hedddItem;
            }
          }
        }
      },
      //カレンダーヘッドの初期化時間
      initCanderValue(tilte) {
        let titleList = tilte.split("月 ")
        let newTitile = titleList[1] + "年" + titleList[0] + "月";

        return newTitile;
      },
      //カレンダーの来月
      calendarNext() {
        this.$refs.calendar.next();

        setTimeout(() => {
          this.canderTitle = this.initCanderValue(this.$refs.calendar.title);
        }, 100);

        this.getValue();
      },
      //カレンダーの前の月
      calendarPrv() {
        this.$refs.calendar.prev();

        setTimeout(() => {
          this.canderTitle = this.initCanderValue(this.$refs.calendar.title);
        }, 100);

        this.getValue();
      },
      //カレンダーデータのロードが完了しました。
      getValue() {
        // データが存在する日食、事区分表示
        for (let hedddlIndex = 0; hedddlIndex < this.hasEventsDateDetailedDataList.length; hedddlIndex++) {

          let eachDayDetailedData = this.hasEventsDateDetailedDataList[hedddlIndex];

          for (let eachDayDetailedDatakey in eachDayDetailedData) {

            //当日の食事は区分表示
            for (let mealClassIndex = 0; mealClassIndex < this.mealNames.length; mealClassIndex++) {

              let edddIndex = 0;

              for (edddIndex = 0; edddIndex < eachDayDetailedData[eachDayDetailedDatakey].length; edddIndex++) {
                if (this.mealNames[mealClassIndex].meal_class == eachDayDetailedData[eachDayDetailedDatakey][edddIndex].meal_class) {

                  this.events.push({
                    name: this.mealNames[mealClassIndex].meal_name,
                    start: eachDayDetailedDatakey,
                    color: this.colors[mealClassIndex],
                    timed: false,
                    count: eachDayDetailedData[eachDayDetailedDatakey][edddIndex].reserve_flg_count
                  });
                  break;
                }
              }

              if (edddIndex == eachDayDetailedData[eachDayDetailedDatakey].length) {
                this.events.push({
                  name: this.mealNames[mealClassIndex].meal_name,
                  start: eachDayDetailedDatakey,
                  color: this.colors[mealClassIndex],
                  timed: false,
                  count: "0"
                });
              }

            }
          }
        }

        setTimeout(() => {
          // disableを含む要素を見つけて、スタイルを追加します
          this.$(".v-calendar-weekly__day:has(div.disable)").addClass("mask");
        }, 100);
      },
    },
  };
</script>

<style lang="scss">
  .noPaddingBtm {
    padding-bottom: 0px;
  }

  .ryouSelectStyle {
    width: 250px;
    height: 40px;
  }

  .OfferTitle {
    padding: 0px 55px;
  }

  .mask {
    box-sizing: border-box;
    border: 1px solid #9E9E9E !important;
    background-color: #bebebe !important;
  }
</style>